import React from 'react';

function UserSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7Z" />
      <path d="M12.0228 13.0108C15.1008 13.0108 17.5867 14.3817 19.4805 17.145L19.6742 17.4359C20.3677 18.5057 20.0626 19.9352 18.9927 20.6287C18.6722 20.8364 18.306 20.9608 17.9273 20.9921L17.7371 21H6.30851C5.03355 21 4 19.9664 4 18.6915C4 18.2459 4.12897 17.8098 4.37134 17.4359C6.28811 14.4786 8.8386 13.0108 12.0228 13.0108Z" />
    </svg>
  );
}

export default UserSolid;
